.root {
  height: 4px;
  width: 200px;
  background: var(--color-cream);
  border-radius: 111px;
  overflow: hidden;
  position: relative;
}

.inner {
  background-color: var(--color-bright-green);
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  will-change: width;
}
